<template>
  <div class="statisticsExport">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label name></el-tab-pane>
      <el-tab-pane label="日统计" name="day" class="table">
        <keep-alive>
          <Statistics :isActive="isActive" v-if="tabRefresh.day" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="月统计" name="month" class="table">
        <keep-alive>
          <Statistics :isActive="isActive" v-if="tabRefresh.month" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="年统计" name="year" class="table">
        <keep-alive>
          <Statistics :isActive="isActive" v-if="tabRefresh.year" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="总计" name="sum" class="table">
        <keep-alive>
          <Statistics :isActive="isActive" v-if="tabRefresh.sum" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="指定时间" name="choiceTime" class="table">
        <keep-alive>
          <Statistics :isActive="isActive" v-if="tabRefresh.choiceTime" />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Statistics from "./components/Statistics.vue";
export default {
  name: "StatisticsReport",
  components: { Statistics },
  data() {
    return {
      activeName: "day",
      isActive: "day",
      tabRefresh: {
        day: true,
        month: false,
        year: false,
        sum: false,
        choiceTime: false,
      },
    };
  },
  methods: {
    // 切换tabs触发
    handleClick(val) {
      // sessionStorage.setItem("activeName", val.name);
      // this.activeName = sessionStorage.getItem("activeName");
      this.isActive = val.name;
      switch (this.isActive) {
        case "day":
          this.switchTab("day");
          break;
        case "month":
          this.switchTab("month");
          break;
        case "year":
          this.switchTab("year");
          break;
        case "sum":
          this.switchTab("sum");
          break;
        case "choiceTime":
          this.switchTab("choiceTime");
          break;
      }
    },
    switchTab(tab) {
      for (let key in this.tabRefresh) {
        if (key === tab) {
          this.tabRefresh[key] = true;
        } else {
          this.tabRefresh[key] = false;
        }
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.el-tabs {
  height: calc(100% - 10px);
  /deep/ .el-tabs__content {
    height: calc(100% - 40px);
    overflow: auto;
    .el-tab-pane {
      height: 100%;
    }
  }
}
.el-tabs /deep/ .el-tabs__header {
  background: #fff;
  margin-bottom: 20px;
}
.el-tabs /deep/ #tab-0 {
  padding: 0;
  height: 0;
}
/deep/ .el-radio {
  padding: 0;
  width: 80px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  border-radius: 16px;
  .el-radio__label {
    padding: 0;
    font-size: 14px;
  }
}
/deep/ .el-radio__inner {
  display: none;
}
/deep/ .el-tabs__item {
  font-weight: bold;
}
/deep/ .el-tabs__nav-wrap::after {
  background-color: #fff;
}
::v-deep .selectInput input::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: #333;
}
::v-deep .selectInput input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 适配火狐 */
  color: #333;
}
::v-deep .selectInput input::-moz-placeholder {
  /* Mozilla Firefox 19+ 适配火狐 */
  color: #333;
}
::v-deep .selectInput input:-ms-input-placeholder {
  /* Internet Explorer 10+  适配ie*/
  color: #333;
}
::v-deep .el-input__prefix {
  left: auto;
  right: 10px;
  color: #333;
}
.query-box /deep/ .el-date-editor {
  width: 100% !important;
}
.date-input /deep/ {
  .el-form-item__content {
    width: 620px;
    .el-col-1 {
      margin-left: 18px !important;
    }
  }
}
.con-wrap /deep/ .mini-dialog .el-form-item__label {
  width: 110px;
  margin-left: 0;
}
// .selectBox .selectInput /deep/ .el-input__inner {
//   cursor: pointer !important;
//   -webkit-user-select: none;
//   -moz-user-select: none;
//   -ms-user-select: none;
//   user-select: none;
// }
// ::v-deep .el-input__suffix {
//   right: 10px !important;
// }
// ::v-deep .el-select .el-input .el-select__caret.el-input__icon::before {
//   content: "";
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   top: 50%;
//   left: 50%;
//   color: #333;
//   transform: translate(-50%, -50%);
// }
.statisticsExport {
  margin: 20px;
  height: calc(100% - 40px);
  background-color: #f8f8f8;
  .statisticsBox {
    width: 100%;
    height: calc(100% - 10px);
    background: #fff;
  }
}
</style>